// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner___H2Rx","errorLogs":"EditorFooter_errorLogs__6NdLI"};